import cl from "./ProductCard.module.css";
import { NavLink, useParams } from "react-router-dom";
import React, { useEffect, useState } from "react";
import Comments from "../../../Comments/Comments";
import { animateScroll as scroll } from "react-scroll";
import { getRandomNumber } from "../../../Home/Home";

const ProductCard = (props) => {
  useEffect(() => {
    scroll.scrollToTop();
  }, []);

  const productPath = useParams().path;
  const product = props.productsData.find(
    (product) => product.path === encodeURIComponent(productPath)
  );
  const image = product.images ? product.images[0] : null;
  const [mainImage, setMainImage] = useState(image);
  const [isAdded, setIsAdded] = useState(false);

  let onClick = () => {
    props.onAdd(props);
    setIsAdded(true);
  };

  useEffect(() => {
    if (ifChecked()) setIsAdded(true);
  }, []);

  function ifChecked() {
    if (props.cartItems.some((item) => item.productId === props.productId)) {
      return true;
    } else {
      return false;
    }
  }

  const onMouseOver = (img) => () => {
    setMainImage(img);
  };
  let productDescrImages = product.imagesAbout?.map((p) => (
    <img
      alt="info"
      className={cl.description_image}
      src={p}
      key={getRandomNumber(1, 10000)}
    />
  ));
  let newPrice = ((product.oldPrice * (100 - product.discount)) / 100).toFixed(
    2
  );

  return (
    <section
      itemScope
      itemType="https://schema.org/Product"
      className="section"
    >
      <div className={cl.productcard}>
        <div className={cl.productcard_images}>
          <div className={cl.mini_images}>
            {product.images?.map((image) => (
              <img
                src={image}
                itemProp="image"
                onMouseOver={onMouseOver(image)}
                alt=""
                key={getRandomNumber(1, 10000)}
              />
            ))}
          </div>
          <img className={cl.big_image} src={mainImage} alt="" />
        </div>
        <div className={cl.main_productcard}>
          <h4 className={cl.main_productcard_name} itemProp="name">
            {product.name}
          </h4>
          <p
            className={cl.main_productcard_price}
            itemProp="offers"
            itemScope
            itemType="https://schema.org/Offer"
          >
            <span itemProp="price">
              {product.currency}
              {newPrice}
            </span>
          </p>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "20px",
            }}
          >
            <div className={cl.main_productcard_recomended}>
              <svg
                viewBox="0 0 24 24"
                width="30px"
                height="30px"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                <g
                  id="SVGRepo_tracerCarrier"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></g>
                <g id="SVGRepo_iconCarrier">
                  {" "}
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6.30147 15.5771C4.77832 14.2684 3.6904 12.7726 3.18002 12C3.6904 11.2274 4.77832 9.73158 6.30147 8.42294C7.87402 7.07185 9.81574 6 12 6C14.1843 6 16.1261 7.07185 17.6986 8.42294C19.2218 9.73158 20.3097 11.2274 20.8201 12C20.3097 12.7726 19.2218 14.2684 17.6986 15.5771C16.1261 16.9282 14.1843 18 12 18C9.81574 18 7.87402 16.9282 6.30147 15.5771ZM12 4C9.14754 4 6.75717 5.39462 4.99812 6.90595C3.23268 8.42276 2.00757 10.1376 1.46387 10.9698C1.05306 11.5985 1.05306 12.4015 1.46387 13.0302C2.00757 13.8624 3.23268 15.5772 4.99812 17.0941C6.75717 18.6054 9.14754 20 12 20C14.8525 20 17.2429 18.6054 19.002 17.0941C20.7674 15.5772 21.9925 13.8624 22.5362 13.0302C22.947 12.4015 22.947 11.5985 22.5362 10.9698C21.9925 10.1376 20.7674 8.42276 19.002 6.90595C17.2429 5.39462 14.8525 4 12 4ZM10 12C10 10.8954 10.8955 10 12 10C13.1046 10 14 10.8954 14 12C14 13.1046 13.1046 14 12 14C10.8955 14 10 13.1046 10 12ZM12 8C9.7909 8 8.00004 9.79086 8.00004 12C8.00004 14.2091 9.7909 16 12 16C14.2092 16 16 14.2091 16 12C16 9.79086 14.2092 8 12 8Z"
                    fill="#000000"
                  ></path>{" "}
                </g>
              </svg>
              {Math.floor(Math.random() * (200 - 100 + 1)) + 100}
            </div>

            <div className={cl.main_productcard_recomended}>
              <svg
                viewBox="0 0 24 24"
                width="30px"
                height="30px"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                <g
                  id="SVGRepo_tracerCarrier"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></g>
                <g id="SVGRepo_iconCarrier">
                  {" "}
                  <path
                    d="M8 10V20M8 10L4 9.99998V20L8 20M8 10L13.1956 3.93847C13.6886 3.3633 14.4642 3.11604 15.1992 3.29977L15.2467 3.31166C16.5885 3.64711 17.1929 5.21057 16.4258 6.36135L14 9.99998H18.5604C19.8225 9.99998 20.7691 11.1546 20.5216 12.3922L19.3216 18.3922C19.1346 19.3271 18.3138 20 17.3604 20L8 20"
                    stroke="#000000"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>{" "}
                </g>
              </svg>
              {Math.floor(Math.random() * (200 - 100 + 1)) + 100}
            </div>
          </div>

          <div className={cl.main_productcard_bottons}>
            <NavLink style={{ display: "flex" }} to="/products">
              <button
                className={cl.main_productcard_buynow}
                onClick={() => props.onBuyItNow(product)}
              >
                Compra ahora
              </button>
            </NavLink>
          </div>
          <div className={cl.description} itemProp="description">
            <p
              style={{
                fontWeight: "800",
                fontSize: "24px",
                marginTop: "20px",
                marginBottom: "10px",
              }}
            >
              Información del producto
            </p>
            {product.description}
          </div>
        </div>
      </div>
      <p style={{ textAlign: "center", marginTop: "40px", fontSize: "30px" }}>
        Con más detalle
      </p>
      {product.info ? (
        <div itemProp="description" className={cl.table_description}>
          <table style={{ width: "100%" }}>
            <tbody>
              {Object.entries(product.info).map(([key, value]) => (
                <tr key={getRandomNumber(1, 10000)}>
                  <td
                    style={{
                      fontWeight: "bold",
                      padding: "0.5rem 2rem 0.5rem 0.5rem",
                    }}
                  >
                    {key}
                  </td>
                  <td style={{ padding: "0.5rem" }}>{value}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <> </>
      )}
      {product.features ? (
        <div
          itemProp="description"
          style={{
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            margin: "3rem 0",
          }}
        >
          <p
            style={{
              marginBottom: "1.5rem",
              fontSize: "30px",
              textAlign: "center",
            }}
          >
            Características del producto
          </p>
          <ul className={cl.product_features}>
            {product.features?.map((feature) => (
              <li style={{ margin: "0.5rem 0" }} key={getRandomNumber(1, 10000)}>
                {feature}
              </li>
            ))}
          </ul>
        </div>
      ) : null}

      <div className={cl.description}>{productDescrImages}</div>
      <Comments comments={product.comments} rating={product.rating} />
    </section>
  );
};

export default ProductCard;
